
window.addEventListener('DOMContentLoaded', (event) => {
    //data-features
    let readMoreShow = 10;
    let cnt=1;
    let dvReadMore = '<button type="button" class="mt-8 w-full cursor-pointer underline read-more" read-more="down" >Show More</button>';
    document.querySelectorAll('[data-features]').forEach(item => {
        item.setAttribute("id", "rm-" + (cnt++).toString());
        if(item.getElementsByTagName("li").length <= readMoreShow)
            return;

        item.insertAdjacentHTML('afterend', dvReadMore);
        ShowHide(item, true)
        /*Read More click*/
        item.nextSibling?.addEventListener('click', event => {
            var targetElement: any = event.target || event.srcElement;
            let readMoreAttr = targetElement.getAttribute("read-more");
            const ulEl:any = targetElement.previousSibling;
            //console.log('readMoreAttr: ',readMoreAttr);
            ShowHide(ulEl, readMoreAttr === "up");

            if(readMoreAttr === "down")
            {
                targetElement.setAttribute("read-more","up");
                targetElement.innerHTML = "Show Less";
            }
            else{
                targetElement.setAttribute("read-more","down");
                targetElement.innerHTML = "Show More";
            }




        })
    })

    function ShowHide(ulEl:any,isHide:boolean) {

        for (var i = 0; i < ulEl.getElementsByTagName("li").length; ++i) {
            let _li=ulEl.getElementsByTagName("li")[i];
            if(i >= readMoreShow)
            {
                if(isHide)
                {
                    //console.log('add hidden');
                    _li.classList.add("hidden");
                }
                else{
                    //console.log('remove hidden');
                    _li.classList.remove("hidden");
                }

            }
        }
    }
});

export {};